<div class="sidenav-header" [class.collapsed]="collapsed()">
    <div class="gov-logo" [class.collapsed]="collapsed()">
        @if (collapsed()) {
            <img src="/assets/img/stayamev-side.svg" alt="" />
        } @else {
            <img src="/assets/img/government-india-side.svg" alt="" />
        }
    </div>
    <button class="menu-toggle" [class.close-menu]="collapsed()" (click)="collapsed.set(!collapsed())">
        <img src="/assets/img/menu-toggle-side.svg" alt="" />
    </button>
</div>
<mat-nav-list [disableRipple]="true">
    @for (item of menuItems(); track item.label) {
        <side-nav-menu [item]="item" [collapsed]="collapsed()" [level]="0" />
    }
</mat-nav-list>
